export enum TemplateType {
    ICCA = 0,
    Termsheets = 1,
    UserAgreements = 2,
    Notices = 3,
}

export const TemplateTypeOptions = [
    {
        id: TemplateType.ICCA,
        name: 'ICCA Templates',
    },
    {
        id: TemplateType.Termsheets,
        name: 'Termsheet Templates',
    },
    {
        id: TemplateType.UserAgreements,
        name: 'User Agreement Templates',
    },
    {
        id: TemplateType.Notices,
        name: 'Notice Templates',
    },
];
